module.exports = "/_next/static/videos/trees-about-bb00209c55175bd74797d35cb018c15d.mp4";